import "./styles.css";
import { HoopDreamsGame } from "./game/Game";
import { renderStore } from "./store";

const app = document.querySelector<HTMLElement>("#app");
if (!app) throw new Error("Application root is missing");

if (location.pathname.startsWith("/store")) {
  document.title = "Hoop Dreams on Steam";
  renderStore(app);
} else {
  app.innerHTML = `
    <main class="game-shell" data-state="menu">
      <header class="game-header">
        <a class="mini-brand" href="/" aria-label="Hoop Dreams home"><span>🏀</span> HOOP DREAMS</a>
        <div class="header-actions">
          <a href="/store">STORE</a>
          <button id="sound-button" type="button" aria-label="Mute sound">◖))</button>
          <button id="fullscreen-button" type="button" aria-label="Fullscreen">⛶</button>
          <button id="pause-button" type="button" aria-label="Pause">Ⅱ</button>
        </div>
      </header>
      <section class="game-stage" aria-label="Hoop Dreams game">
        <canvas id="game-canvas" aria-label="Basketball court. Drag an athlete and release toward the hoop."></canvas>
        <div class="court-status" aria-live="polite"><span id="mode">Street Career</span><b>WIND <i id="wind">CALM 0</i></b></div>
        <div class="hud" aria-live="polite">
          <div><span>SCORE</span><strong id="score">00</strong></div>
          <div><span>STREAK</span><strong id="streak">—</strong></div>
          <div class="time-box"><span>TIME</span><strong id="time">60</strong></div>
          <div><span>BEST</span><strong id="best">00</strong></div>
        </div>
        <div id="game-overlay" class="game-overlay"></div>
      </section>
      <footer class="game-footer">
        <span>Distance pays 1–3× · Read the wind · Release through the rim</span>
        <span><kbd>P</kbd> pause <kbd>M</kbd> mute</span>
      </footer>
    </main>
  `;

  const required = <T extends Element>(selector: string): T => {
    const element = app.querySelector<T>(selector);
    if (!element) throw new Error(`Required element is missing: ${selector}`);
    return element;
  };

  new HoopDreamsGame({
    shell: required(".game-shell"),
    canvas: required("#game-canvas"),
    overlay: required("#game-overlay"),
    score: required("#score"),
    time: required("#time"),
    best: required("#best"),
    streak: required("#streak"),
    mode: required("#mode"),
    wind: required("#wind"),
    pauseButton: required("#pause-button"),
    soundButton: required("#sound-button"),
    fullscreenButton: required("#fullscreen-button"),
  });
}
